import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import ToastNotification from "components/Toast/ToastNotification"

const WishlistNotification = forwardRef(({ message, subtext, testId }, ref) => (
  <ToastNotification ref={ref} testId={testId}>
    <div className="flex items-center justify-between">
      <div>
        <div className="font-sans font-medium">{message}</div>
        {subtext && (
          <div className="text-xs text-gray-500 md:text-sm">{subtext}</div>
        )}
      </div>
      <div>
        <Link
          to="/wishlist"
          className="font-sans text-xs font-bold uppercase tracking-wider md:text-sm"
        >
          View
        </Link>
      </div>
    </div>
  </ToastNotification>
))

WishlistNotification.defaultProps = {
  subtext: undefined,
  testId: undefined
}

WishlistNotification.propTypes = {
  message: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  testId: PropTypes.string
}

export default WishlistNotification
